const operator = {
  LESS_THAN: 'LESS_THAN',
  EQUALT_TO: 'EQUALT_TO',
  MORE_THAN: 'MORE_THAN',
};

export default operator;
